import React from 'react';

function Message({ message, type = 'error', onClose }) {
  const messageStyles = {
    error: 'text-red-500 bg-red-100 border-red-500',
    success: 'text-green-500 bg-green-100 border-green-500',
    warning: 'text-yellow-500 bg-yellow-100 border-yellow-500',
    info: 'text-blue-500 bg-blue-100 border-blue-500',
  };

  const selectedStyle = messageStyles[type] || messageStyles.error; // Default to error if type is not provided

  return (
    <div className={`flex fixed top-4 right-4 z-50 border-l-4 p-4 mt-2 rounded relative ${selectedStyle}`} role="alert">
      <span className="block sm:inline">{message}</span>
      <span className="block sm:inline">
        <button
          onClick={onClose}
          className="absolute right-2 top-1 text-gray-600 dark:text-gray-200">
          &times;
        </button>
      </span>
    </div>
  );
}

export default Message;
